import { Action, createReducer, on } from '@ngrx/store';
import { initialStateSimulationData, ISimulationData } from '../states/simulation.state';
import { LoadSimulationSuccess } from '../actions/simulation.action';


const simulationDataReducer = createReducer(
  initialStateSimulationData,
  on(LoadSimulationSuccess, (_state, { simulationData }) => simulationData)
);

export function simulationReducer(state: ISimulationData, action: Action) {
  return simulationDataReducer(state, action);
}
